export enum Roles {
    installer = 'installer',
    employee = 'employee'
}